const COMPANY_STAFF_SESSION_KEY = 'companyStaffSession';

const safeParse = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const sanitize = (raw = {}) => {
  const staffProfile = {
    name: String(raw?.name || '').trim(),
    role: String(raw?.role || '').trim(),
    mobileNumber: String(raw?.mobileNumber || '').trim(),
    employeeId: String(raw?.employeeId || '').trim(),
  };

  if (!staffProfile.name || !staffProfile.role || !staffProfile.mobileNumber) {
    return null;
  }

  return staffProfile;
};

export const getCompanyStaffSession = () => {
  if (typeof window === 'undefined') return null;
  const parsed = safeParse(localStorage.getItem(COMPANY_STAFF_SESSION_KEY) || '');
  return sanitize(parsed);
};

export const saveCompanyStaffSession = (staffProfile) => {
  if (typeof window === 'undefined') return null;
  const sanitized = sanitize(staffProfile);
  if (!sanitized) return null;
  localStorage.setItem(COMPANY_STAFF_SESSION_KEY, JSON.stringify(sanitized));
  return sanitized;
};

export const clearCompanyStaffSession = () => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(COMPANY_STAFF_SESSION_KEY);
};

export const mergeUserWithStaffSession = (user) => {
  if (!user || typeof user !== 'object') return user;
  const staff = getCompanyStaffSession();
  if (!staff) return user;
  return {
    ...user,
    staffProfile: user.staffProfile || staff,
  };
};

export const getStaffPayloadFromUser = (user) => {
  if (!user || typeof user !== 'object') return getCompanyStaffSession();
  return sanitize(user.staffProfile || getCompanyStaffSession());
};
